let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6SpbU"), load("dMWJp")]).then(() => parcelRequire('eTW2b'));